/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5204f8b7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "drawer bg-backgroundDrawer"
};
const _hoisted_2 = ["checked"];
const _hoisted_3 = {
  class: "drawer-content"
};
const _hoisted_4 = {
  class: "drawer-side ml-[68px] z-50 mt-navBarHeight"
};
const _hoisted_5 = {
  class: "menu flex flex-col flex-nowrap h-[calc(100%-64px)] w-[400px] p-4 bg-backgroundDrawer"
};
const _hoisted_6 = {
  class: "relative flex items-center pb-10"
};
const _hoisted_7 = {
  key: 0,
  class: "text-2xl text-white"
};
const _hoisted_8 = {
  class: "editor-drawer__components-wrapper hide-scrollbar overflow-y-auto"
};
import { storeToRefs } from "pinia";
import { useConfiguratorStore } from "@/stores/configurator";
import { vOnClickOutside } from '@vueuse/components';
import EditorDrawerText from "@/components/configurator/sidebar/drawer/EditorDrawerText";
import EditorDrawerImages from "@/components/configurator/sidebar/drawer/EditorDrawerImages";
import EditorDrawerBackground from "@/components/configurator/sidebar/drawer/EditorDrawerBackground";
import EditorDrawerShapes from "@/components/configurator/sidebar/drawer/EditorDrawerShapes";
import EditorDrawerSettings from "@/components/configurator/sidebar/drawer/EditorDrawerSettings";
export default {
  __name: 'Drawer',
  setup(__props) {
    const configuratorStore = useConfiguratorStore();
    const {
      checkedDrawer
    } = storeToRefs(configuratorStore);
    const {
      closeDrawer
    } = configuratorStore;
    const {
      activeDrawerComponentIndex
    } = storeToRefs(configuratorStore);
    const activeDrawerComponentTranslationKey = computed(() => {
      switch (activeDrawerComponentIndex.value) {
        case 1:
          return 'configurator.text';
        case 2:
          return 'configurator.images';
        case 3:
          return 'configurator.background';
        case 4:
          return 'configurator.shapes';
        case 5:
          return 'configurator.settings';
        default:
          break;
      }
    });
    const activeDrawerComponent = computed(() => {
      switch (activeDrawerComponentIndex.value) {
        case 1:
          return EditorDrawerText;
        case 2:
          return EditorDrawerImages;
        case 3:
          return EditorDrawerBackground;
        case 4:
          return EditorDrawerShapes;
        case 5:
          return EditorDrawerSettings;
        default:
          break;
      }
    });
    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        id: "my-drawer",
        type: "checkbox",
        class: "drawer-toggle",
        checked: _unref(checkedDrawer)
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default")]), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("header", _hoisted_6, [_unref(activeDrawerComponentTranslationKey) ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$t(_unref(activeDrawerComponentTranslationKey))), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "ml-auto",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(closeDrawer) && _unref(closeDrawer)(...args))
      }, [_createVNode(_component_SvgIcon, {
        class: "w-6 h-6",
        fill: "white",
        svgSymbolId: "close"
      })])]), _createElementVNode("div", _hoisted_8, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(activeDrawerComponent))))])])), [[_unref(vOnClickOutside), _unref(closeDrawer)]])])]);
    };
  }
};